import React, { useState } from "react";
import "./ForgetPassword.css";
import swal from "sweetalert";
import { useNavigate } from "react-router-dom";
import ApiService from "../../Frontend/Api/ApiServices";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import FormGroup from "../../Components/Common/FormGroup";
import InputField from "../../Components/Common/InputField";

const ForgetPassword = () => {
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const validationSchema = Yup.object({
    email: Yup.string()
      .email("Invalid email address")
      .required("Email is required"),
  });

  const handleSubmit = async (values, { setSubmitting, setErrors, resetForm }) => {
    try {
      setIsLoading(true);
      const payload = { email: values.email };
      const { data } = await ApiService.forgetPassword(payload);
      if (data?.OK) {
        swal({
          title: "Email Sent!",
          text: data?.message || "Check your inbox.",
          icon: "success",
        });
        resetForm();
      } else {
        setErrors({ email: "Email Address is not found" });
      }
    } catch (error) {
      console.error(error);
      if (error.code === "ERR_NETWORK") {
        swal("Network Error!", "Failed to connect server.", "error");
        return;
      }
      swal("Failed!", "Failed to send email.", "error");
    } finally {
      setIsLoading(false);
      setSubmitting(false);
    }
  };

  return (
    <div className="main">
      <div className="container-forget">
        <Formik
          initialValues={{ email: "" }}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ isSubmitting, getFieldProps }) => (
            <Form>
              <h1>Forgot Password</h1>
              <div className="field-forget">

                <FormGroup
                  label="Enter Your Email"
                  name="email"
                  className="loginField"
                  svgPath={require("../../Assets/Images/mail-account.png")}
                  requiredField
                >
                  <InputField
                    type="text"
                    name="email"
                    className="textarea"
                    {...getFieldProps("email")}
                  />
                </FormGroup>
              </div>
              <button
                className="btn1-forget"
                type="submit"
                disabled={isLoading || isSubmitting}
              >
                {isLoading ? "Loading..." : "Send email"}
              </button>
              <p
                id="l4"
                style={{
                  paddingTop: "10px",
                  fontSize: "12px",
                  cursor: "pointer",
                  textAlign: "center",
                  margin: 0,
                }}
                onClick={() => {
                  navigate("/members");
                }}
              >
                Return to Login
              </p>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default ForgetPassword;
